import { useEffect } from "react";
import { CookiesProvider } from "react-cookie";
import { persistor, store } from "./store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { Toaster } from "react-hot-toast";
import { ConfigProvider, Empty } from "antd";
import AppRoutes from "./routes/AppRoutes.jsx";
import { getEnv, getColor } from "./utils/utils";

const App = () => {
  const primaryColor = getColor("--theme");

  useEffect(() => {
    const name = getEnv("REACT_APP_NAME", "CapitalFxGlobal");
    if (name) document.title = `Cabinet - ${name}`;
  }, []);

  return (
    <CookiesProvider>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <ConfigProvider
            renderEmpty={() => (
              <Empty
                description="No Record Found"
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            )}
            theme={{
              token: {
                fontFamily: "Public Sans",
                colorPrimary: primaryColor,
              },
            }}
          >
            <Toaster position="top-right" reverseOrder={false} />
            <AppRoutes />
          </ConfigProvider>
        </PersistGate>
      </Provider>
    </CookiesProvider>
  );
};

export default App;
